<template>
  <v-container
    fill-height
    fluid
    class="background"
    style="max-height: 100vh;">
    <v-layout
      align-center
      justify-center>
      <v-flex
        xs12
        sm8
        md4>
        <v-card class="elevation-12">
          <v-toolbar color="heron_toolbar">
            <v-avatar
              color="tranparent"
              size="70">
              <img src="../assets/img/energy-control.png" >
            </v-avatar>
            <v-toolbar-title
              class="toolbar_text--text"
            >Energy Control</v-toolbar-title
            >
            <v-spacer />
            <img
              src="../assets/img/heron_icon.svg"
              width="70" >
          </v-toolbar>
          <p
            align="center"
            class="title font-weight-bold">
            Εγγραφή νόμιμου χρήστη παροχής (1/3)
          </p>
          <v-card-text>
            <v-form>
              <v-text-field
                v-model="firstname"
                :error-messages="firstnameErrors"
                label="Όνομα"
                required
                @input="$v.firstname.$touch()"
                @blur="$v.firstname.$touch()"
              />
              <v-text-field
                v-model="lastname"
                :error-messages="lastnameErrors"
                label="Επώνυμο"
                required
                @input="$v.lastname.$touch()"
                @blur="$v.lastname.$touch()"
              />
              <v-text-field
                v-model="email"
                :error-messages="emailErrors"
                label="E-mail"
                required
                @input="$v.email.$touch()"
                @blur="$v.email.$touch()"
              />
              <v-text-field
                v-model="password"
                :error-messages="passwordErrors"
                :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                :type="showPassword ? 'text' : 'password'"
                label="Κωδικός"
                required
                @input="$v.password.$touch()"
                @blur="$v.password.$touch()"
                @click:append="showPassword = !showPassword"
              />
              <v-text-field
                v-model="phone"
                :error-messages="phoneErrors"
                label="Τηλέφωνο"
                required
                @input="$v.phone.$touch()"
                @blur="$v.phone.$touch()"
              />
              <v-text-field
                v-model="afm"
                :error-messages="afmErrors"
                label="ΑΦΜ"
                required
                @keypress="isNumber()"
                @input="$v.afm.$touch()"
                @blur="$v.afm.$touch()"
              />
              <v-text-field
                v-model="address"
                label="Διεύθυνση"/>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn
              block
              color="heron_info"
              @click="clear">
              καθαρισμος
            </v-btn>
            <v-btn
              block
              color="heron_success"
              @click="register">
              επομενο
            </v-btn>
          </v-card-actions>
          <v-snackbar
            v-model="snackbar"
            :timeout="5000"
            :color="snackColor"
            :top="true"
          >
            {{ errorMessages }}
            <v-btn
              dark
              flat
              @click="snackbar = false">
              Close
            </v-btn>
          </v-snackbar>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, minLength, email } from 'vuelidate/lib/validators'

export default {
  mixins: [validationMixin],

  validations: {
    firstname: { required },
    lastname: { required },
    phone: { required },
    afm: { required, minLength: minLength(9) },
    email: { required, email },
    password: { required, minLength: minLength(6) },
    address: {}
  },

  data: () => ({
    firstname: '',
    lastname: '',
    email: '',
    password: '',
    address: '',
    supplynumber: '',
    kwhprice: '',
    phone: '',
    afm: '',
    showPassword: false,
    errorMessages: '',
    snackbar: false,
    snackColor: '',
    color: 'general',
    firstnameError: false,
    lastnameError: false,
    emailError: false,
    passwordError: false,
    phoneError: false,
    afmError: false
  }),

  computed: {
    firstnameErrors () {
      const errors = []
      if (!this.$v.firstname.$dirty) return errors
      !this.$v.firstname.required && errors.push('Το όνομα είναι υποχρεωτικό')
      this.firstnameError = errors.length != 0
      return errors
    },
    lastnameErrors () {
      const errors = []
      if (!this.$v.lastname.$dirty) return errors
      !this.$v.lastname.required && errors.push('Το επώνυμο είναι υποχρεωτικό')
      this.lastnameError = errors.length != 0
      return errors
    },
    emailErrors () {
      const errors = []
      if (!this.$v.email.$dirty) return errors
      !this.$v.email.email && errors.push('Το e-mail πρέπει να είναι έγκυρο')
      !this.$v.email.required && errors.push('Το e-mail είναι υποχρεωτικό')
      this.emailError = errors.length != 0
      return errors
    },
    passwordErrors () {
      const errors = []
      if (!this.$v.password.$dirty) return errors
      !this.$v.password.minLength &&
        errors.push('Ο κωδικός θα πρέπει να είναι τουλάχιστον 6 χαρακτήρες')
      !this.$v.password.required && errors.push('Ο κωδικός είναι υποχρεωτικός')
      this.passwordError = errors.length != 0
      return errors
    },
    phoneErrors () {
      const errors = []
      if (!this.$v.phone.$dirty) return errors
      !this.$v.phone.required && errors.push('Το τηλέφωνο είναι υποχρεωτικό')
      this.phoneError = errors.length != 0
      return errors
    },
    afmErrors () {
      const errors = []
      if (!this.$v.afm.$dirty) return errors
      !this.$v.afm.minLength &&
        errors.push('Ο ΑΦΜ θα πρέπει να είναι 9 χαρακτήρες')
      !this.checkAFM(this.$v.afm.$model) &&
        errors.push('Ο ΑΦΜ θα πρέπει να είναι έγκυρος')
      !this.$v.afm.required && errors.push('Ο ΑΦΜ είναι υποχρεωτικός')
      this.afmError = errors.length != 0
      return errors
    }
  },

  created () {
    this.firstname =
      this.$route.params.data !== undefined
        ? this.$route.params.data.firstname
        : ''
    this.lastname =
      this.$route.params.data !== undefined
        ? this.$route.params.data.lastname
        : ''
    this.email =
      this.$route.params.data !== undefined
        ? this.$route.params.data.email
        : ''
    this.password =
      this.$route.params.data !== undefined
        ? this.$route.params.data.password
        : ''
    this.address =
      this.$route.params.data !== undefined
        ? this.$route.params.data.address
        : ''
    this.phone =
      this.$route.params.data !== undefined
        ? this.$route.params.data.phone
        : ''
    this.afm =
      this.$route.params.data !== undefined ? this.$route.params.data.afm : ''
  },

  methods: {
    register () {
      this.$v.$touch()
      if (
        this.firstname == '' ||
        this.lastname == '' ||
        this.email == '' ||
        this.password == '' ||
        this.phone == '' ||
        this.afm == ''
      ) {
        this.requiredInline()
      } else if (
        !this.firstnameError &&
        !this.lastnameError &&
        !this.passwordError &&
        !this.emailError &&
        !this.phoneError &&
        !this.afmError
      ) {
        let firstname = this.firstname
        let lastname = this.lastname
        let email = this.email
        let password = this.password
        let address = this.address
        let phone = this.phone
        let afm = this.afm

        this.$router.push({
          name: 'user_terms',
          params: {
            data: { firstname, lastname, email, password, address, phone, afm }
          }
        })
      }
    },

    checkAFM (afm) {
      var vat_number = afm

      var count_digits = vat_number.length
      var array = vat_number.split('')

      var sum_of_digits = 0
      for (i = 0; i < 9; i++) {
        sum_of_digits = sum_of_digits + Number(vat_number[i])
      }

      if (count_digits != 9 || sum_of_digits == 0) {
        return false
        // console.log("Vat number  is invalid");
      } else {
        // A1 calculation as the readme.md file describes
        var m = 256
        var a1 = 0
        var i = 1
        for (i = 0; i < 8; i++) {
          a1 = a1 + Number(array[i]) * m
          m = m / 2
        }

        // A2 calculation as the readme.md file describes
        var a2 = a1 % 11

        // Check if c9 is equal with a2 modulo 10
        if (Number(array[8]) == a2 % 10) {
          return true
          // console.log("Vat number is valid!");
        } else {
          return false
          // console.log("Vat number is invalid!");
        }
      }
    },

    isNumber (evt) {
      evt = evt || window.event
      let charCode = evt.which || evt.keyCode
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault()
      } else {
        return true
      }
      return false
    },

    clear () {
      this.$v.$reset()
      this.firstname = ''
      this.lastname = ''
      this.email = ''
      this.password = ''
      this.address = ''
      this.supplynumber = ''
      this.kwhprice = ''
      this.phone = ''
      this.afm = ''
    },
    requiredInline () {
      this.snackbar = true
      this.snackColor = 'error'
      this.errorMessages = 'Παρακαλώ συμπληρώστε όλα τα απαιτούμενα πεδία'
    }
  },
  metaInfo () {
    return {
      title: 'HERON Energy Control'
    }
  }
}
</script>

<style scoped>
.background {
  background: url("../assets/img/heron_background_new.jpg");
  background-size: cover;
  width: 100%;
  height: 100%;
}
.v-tooltip__content {
  background-color: white;
  border-radius: 8px;
}
.v-toolbar__title {
  font-size: 1.5rem !important;
}
</style>
